"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MealDeal = void 0;
var values_1 = __importDefault(require("lodash/values"));
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var get_1 = __importDefault(require("lodash/get"));
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var getBundlePromoValue_1 = require("./getBundlePromoValue");
var util_1 = require("./util");
var distributeDiscountAmount_1 = require("./distributeDiscountAmount");
exports.MealDeal = {
    mapFromBasket: function (bundles, includeOnlyDiscounted) {
        if (includeOnlyDiscounted === void 0) { includeOnlyDiscounted = true; }
        var hasDealPromo = function (bundle) { return (0, get_1.default)(bundle, 'deal.promotion.value', 0) > 0; };
        var bundlesWithDiscountedMealDeal = includeOnlyDiscounted
            ? bundles.filter(hasDealPromo)
            : bundles;
        return (0, groupBy_1.default)(bundlesWithDiscountedMealDeal, "deal.basketUUID");
    },
    discountedTotal: function (mealDealMap, promotion) {
        var discountedTotal = (0, util_1.currency)(0);
        (0, values_1.default)(mealDealMap).forEach(function (dealBundles) {
            var dealFinalPrice = util_1.Bundle.priceTotal(dealBundles);
            var discountedAmount = (0, getBundlePromoValue_1.getBundlePromoValue)(dealFinalPrice, promotion);
            discountedTotal = discountedTotal.add(discountedAmount);
        });
        return discountedTotal.value;
    },
    discountedBundles: function (bundles) { return bundles.filter(function (bundle) { return (0, get_1.default)(bundle, 'deal.promotion'); }); },
    priceTotal: function (mealDealMap) {
        return (0, values_1.default)(mealDealMap).reduce(function (total, dealBundles) { return total.add(util_1.Bundle.priceTotal(dealBundles)); }, (0, util_1.currency)(0));
    },
    distributeDiscount: function (mealDealMap, discountAmount, promo) {
        var resultedBundles = [];
        var dealsTotalPrice = exports.MealDeal.priceTotal(mealDealMap);
        var discountAmounts = [];
        (0, values_1.default)(mealDealMap).forEach(function (dealBundles) {
            var dealFinalPrice = util_1.Bundle.priceTotal(dealBundles);
            var discountedAmount = (0, util_1.currency)(discountAmount, { precision: 2 })
                .divide(dealsTotalPrice)
                .multiply(dealFinalPrice).value;
            discountAmounts.push(discountedAmount);
        });
        var totalDiscounted = discountAmounts.reduce(function (total, item) { return total.add(item); }, (0, util_1.currency)(0)).value;
        var discountDiff = (0, util_1.currency)(discountAmount).subtract(totalDiscounted).value;
        if (discountDiff !== 0) {
            var lastItem = discountAmounts.length - 1;
            discountAmounts[lastItem] = (0, util_1.currency)(discountAmounts[lastItem]).add(discountDiff).value;
        }
        (0, values_1.default)(mealDealMap).forEach(function (dealBundles, index) {
            var dealFinalPrice = util_1.Bundle.priceTotal(dealBundles);
            var discountedBundles = (0, distributeDiscountAmount_1.distributeDiscountAmount)(dealBundles, discountAmounts[index], dealFinalPrice, promo);
            resultedBundles = resultedBundles.concat(discountedBundles);
        });
        return resultedBundles;
    },
    getMostExpensive: function (basket) {
        var mealDealMap = exports.MealDeal.mapFromBasket(basket, false);
        var mealDealBasketUUIDs = Object.keys(mealDealMap).filter(function (mealDealKey) { return mealDealKey !== "undefined"; });
        var mostExpensive = (0, orderBy_1.default)(mealDealBasketUUIDs.map(function (basketUUID) { return ({
            basketUUID: basketUUID,
            price: util_1.Bundle.priceTotal(mealDealMap[basketUUID]),
        }); }), "price")
            .reverse()
            .shift();
        return mostExpensive;
    },
};
